const colorCalc = (index, questionindex, colors) => {
  const localcolors = questionindex % 2 === 0 ? [...colors].reverse() : colors
  return localcolors[index % colors.length]
}

export default colorCalc
